export const classes = {
  message:
    'w-full px-5 py-2 text-lg text-grey-6 dark:text-mauve-3 text-center font-normal',
};
